import { render, staticRenderFns } from "./search-items.vue?vue&type=template&id=5d52809a"
import script from "./search-items.vue?vue&type=script&lang=js"
export * from "./search-items.vue?vue&type=script&lang=js"
import style0 from "./search-items.vue?vue&type=style&index=0&id=5d52809a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports